/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Menu_Pulse_HintInputs */



/**
* | output |
* | --- |
* | "Flags the week that moved" |
*
* @param {Products_Menu_Pulse_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_menu_pulse_hint = /** @type {((inputs?: Products_Menu_Pulse_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Menu_Pulse_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Замечает перемены за неделю")
	return /** @type {LocalizedString} */ ("Flags the week that moved")
});